import { take, put, select } from 'redux-saga/effects';
import { getEditableAd } from 'selectors/adCreation';
import { FETCH_USER_FLAGS_SUCCESS } from 'actions/featureFlags';
import { RECEIVE_USER_INFO } from 'actions/user';
import * as actions from 'actions/validation';

/**
 * The presence of some fields are determined by feature flags, which
 * has to be fetched after the initial field validation takes place.
 * This saga waits for the flags to return to trigger another
 * validation for the feature flagged fields.
 */
// Not needed anymore, but keeping in case another flag is tied with validation
export function* watchFeatureFlaggedValidation() {
  const { flags } = yield take(FETCH_USER_FLAGS_SUCCESS);

  const fields = yield select(getEditableAd);
  yield put(actions.validateFields({ groups: flags, fields, initialValidation: true }));
}

/*
 * Some fields (totalBudget) are determined by user groups, which
 * has to be fetched after initial field validation takes place.
 * This saga waits for user groups to return to trigger another
 * validation.
 */
export function* watchUserGroupValidation() {
  const { user: { groups } } = yield take(RECEIVE_USER_INFO);

  const fields = yield select(getEditableAd);
  yield put(actions.validateFields({ groups, fields, initialValidation: true }));
}



// WEBPACK FOOTER //
// ./src/middleware/sagas/validation.js